import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'transferDeposit',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        items: [],
        itemsCount: 0,
        selectedRowIndex: -1
      },
      lang: '',
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      ResultColumns: [],
      noDataFound: false,
      keyColumn: 'custkey'
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.fillGridCols();
    this.$root.$on('transfer_deposit_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
      });
    },
    fillGridCols() {
      this.ResultColumns.push({ dataField: 'isSelected', caption: this.$t('activities.selected'), dataType: 'boolean' });
      this.ResultColumns.push({ dataField: 'indexNo', caption: this.$t('activities.depositNo') });
      this.ResultColumns.push({ dataField: 'custkey', caption: this.$t('activities.customerKey') });
      this.ResultColumns.push({ dataField: 'customerName', caption: this.$t('activities.customer') });
      this.ResultColumns.push({ dataField: 'amount', caption: this.$t('activities.amount') });
    },
    setData(info) {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        customerName: info.customerName
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/ransferDepositActivity/SetData', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.TransferDepositSuccess'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/ransferDepositActivity/SetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.TransferDepositSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getData();
    },
    getData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/TransferDepositActivity/GetData', parameter),
        response => {
          if (response.status == 200) {
            this.appData.items = response.data.items;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/TransferDepositActivity/GetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.appData.items = response.data.items;
      //    }
      //  })
      //  .catch(error => {
      //    this.$alertMsg(error.response.data);
      //  });
    },
    setSelectedRowIndex(info) {
      console.log(info);

      if ((info === null) || (info === undefined)) {
        this.appData.selectedRowIndex = -1;
        return;
      }

      console.log(info.newRowIndex);

      this.appData.selectedRowIndex = info.newRowIndex;
    }
  },
}
